import(/* webpackMode: "eager" */ "/app/apps/web/src/app/forgot-password/page.tsx");
